import React, {Component} from "react";
import Glass from "@common-images/glass.svg";
import Plus from "@common-images/plus.svg";
import GlassWater from "@common-images/glassWater.svg";

export default class Index extends Component {
  getCups = (label, value, key, title, WaterActive) => {
      return (
        <div className={`water__body active`}>
          <div className="water__body-title">
            Сколько воды вы обычно пьете?
          </div>
          <div className="water__body-row">
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 1 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(1)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 2 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(2)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 3 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(3)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 4 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(4)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 5 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(5)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 6 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(6)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 7 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(7)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 8 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(8)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 9 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(9)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
            <div
              className={`water__body-row-glass ${
                this.props.CupActive >= 10 ? "active" : ""
              }`}
              onClick={() => this.props.handleCup(10)}
            >
              <img src={Glass} alt="" />
              <img className="glass__water-img" src={GlassWater} alt="" />

              <div className="water__body-row-glass-plus">
                <img src={Plus} alt="" />
              </div>
            </div>
          </div>
        </div>
      );
  };
  render() {
    const { WaterActive, handleWater, WaterTabs, handleCup } = this.props;
    return (
      <>
        {this.getCups()}
      </>
    );
  }
}
